import { Order } from "./order";

export class SummaryResponse {
  constructor(
    public totalNumberOfRecords: string = "0",
    public limit: string = "0",
    public totalNumOfApprovedOrders: number = 0,
    public orders: Array<Order> = [],
  ) {}
}
